import React from 'react';
import EfLink, { EfLinkProps } from '../ef-link';
import getLocal from '@/app/utils/getLocal';
import './index.scss';
import { signupCookie } from '@/utils/cookies/signupCookie';

interface EfNeedLoginLinkProps extends EfLinkProps {
    /**
     * 跳转链接
     */
    text?: string;
    entry_position?: number | string;
}

/**
 * 维护:谢保林
 *
 * 需要登录展示的链接
 */
const EfNeedLoginLink: React.FC<EfNeedLoginLinkProps> = ({ href, text, entry_position = 1, ...reset }) => {
    const { locale } = getLocal();
    const pathname2 = `/${locale}/register?redirect=${href}`;
    const dataLayer = [
        {
            event: 'uaEvent',
            event_name: 'activity_join_login',
            button_name: text,
        },
    ];

    return (
        <EfLink
            onClick={() => {
                signupCookie({ sector_name: text, entry_position });
            }}
            {...reset}
            href={pathname2}
            dataLayer={dataLayer}
        >
            {text}
        </EfLink>
    );
};

export default EfNeedLoginLink;
